import type { CustomFieldDefinition, AuditFields } from "../../types";
import { createBaseService } from "./baseService";

type CustomFieldDefinitionBase = Omit<CustomFieldDefinition, "id" | keyof AuditFields>;

const base = createBaseService<CustomFieldDefinition, CustomFieldDefinitionBase>({
  tableName: "custom_field_definitions",
  searchColumns: ["label", "field_name"],
});

export class CustomFieldService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
